// extracted by mini-css-extract-plugin
module.exports = {"right":"Header_right__2YDax","select":"Header_select__2kKl3","clinic":"Header_clinic__3oJEw"};